// extracted by mini-css-extract-plugin
export default {"form":"sendSmsForm_form__ECuDz","label":"sendSmsForm_label__47xur"};